import React from "react";

const SpinnerIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    className="sql-result-panel__loader-spin"
    aria-hidden="true"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);

/**
 * Segmented Table / Chart control (pill track + sliding white active segment).
 * Toggle stays on Table while visualize API runs; disabled during load / when no charts.
 */
export default function SqlResultViewSwitcher({
  viewMode = "table",
  onViewModeChange,
  showChartSwitch = true,
  switchDisabled = false,
  isChartLoading = false,
  tableContent = null,
  chartContent = null,
}) {
  const isChart = showChartSwitch && viewMode === "chart";
  const toggleLocked = switchDisabled || isChartLoading;
  const toggleShowsChart = isChart && !isChartLoading;

  const selectTable = () => {
    if (!showChartSwitch) return;
    if (toggleLocked && !isChart) return;
    if (toggleShowsChart) onViewModeChange?.("table");
  };

  const selectChart = () => {
    if (!showChartSwitch) return;
    if (toggleLocked || toggleShowsChart || switchDisabled) return;
    onViewModeChange?.("chart");
  };

  return (
    <div className="chat-data-wrapper sql-result-panel-host">
      <div className="sql-result-panel">
        {showChartSwitch ? (
          <div className="sql-result-panel__toolbar table-view-toolbar">
            <div
              className={`sql-result-view-segmented${toggleShowsChart ? " is-chart" : " is-table"}${
                toggleLocked ? " is-locked" : ""
              }`}
              role="group"
              aria-label="Result view"
            >
              <span className="sql-result-view-segmented__indicator" aria-hidden="true" />
              <button
                type="button"
                className={`sql-result-view-segmented__option${
                  !toggleShowsChart ? " is-active" : ""
                }`}
                onClick={selectTable}
                disabled={toggleLocked && !toggleShowsChart}
                aria-pressed={!toggleShowsChart}
                aria-busy={isChartLoading}
              >
                Table
              </button>
              <button
                type="button"
                className={`sql-result-view-segmented__option${
                  toggleShowsChart ? " is-active" : ""
                }`}
                onClick={selectChart}
                disabled={toggleLocked || switchDisabled}
                aria-pressed={toggleShowsChart}
              >
                Chart
              </button>
            </div>
          </div>
        ) : null}

        <div className="sql-result-panel__body">
          {isChartLoading ? (
            <div className="sql-result-panel__loading-overlay">
              <SpinnerIcon />
              <span>Loading chart...</span>
            </div>
          ) : null}
          {viewMode === "table" || isChartLoading ? (
            <div
              className={`sql-result-table-container${
                isChartLoading ? " sql-result-table-container--loading" : ""
              }`}
            >
              {tableContent}
            </div>
          ) : (
            <div className="sql-result-chart-container">{chartContent}</div>
          )}
        </div>
      </div>
    </div>
  );
}
